import { Vector3 } from "three";
const CameraConfig = {
    NEAR: 0.001,
    FAR: 1000,
    FOV: 65,
    OFFSET_THIRD_PERSON: new Vector3(0, 0, 0.07),
    LOOKAT_FIRST_PERSON: new Vector3(0, 0, -0.01),
    LOOKAT_THIRD_PERSON: new Vector3(0, 0, -0.07),
};
export { CameraConfig };
